export default {
    fieldTitle: s => s.fieldTitle,
    fieldText: s => s.fieldText,
    fieldSection: s => s.fieldSection,
    fieldImg: s => s.fieldImg,

    isCreate: s => s.isCreate,
    isTopicCreate: s => s.isTopicCreate
}
